import { httpClient } from '../lib/http-client'

export class MoisesTask {
  config: any

  session: any

  constructor(config: any, session: any) {
    this.config = config
    this.session = session
  }

  async add({ file, operations }: any): Promise<string> {
    const client = httpClient({
      userToken: this.session.token,
      baseUrl: this.config.apiEndpoint,
      headers: this.config.headers
    })

    const data = await client.post('/v3/task', {
      file,
      operations
    })

    return data.taskId
  }
}
